import React, { useState, useEffect } from 'react'
import { Button } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal'
import { DonleeFechtAPI } from '../../api/Donlee';
import ErrorAlert from '../Alerts/ErrorAlert';
import { RenderIf } from '../utils/RenderIf';
import './ModalDonlee.css';
import Accordion from 'react-bootstrap/Accordion';

function ModalDonlee({ client_phone, setClient_phone, locator, setLocator, dataClient, setDataClient }) {
    const [showModal, setShowModal] = useState(false)
    let token = localStorage.getItem('x-access-machine-token');
    const [tempClient_Phone, setTempClient_Phone] = useState("");
    const [handler, setHandler] = useState(0)

    const getClientByPhone = async () => {
        if (tempClient_Phone == "") {
            ErrorAlert("Ingresa el numero telefonico del cliente", "Debes ingresar el numero", "warning");
        } else {


            try {
                const response = await DonleeFechtAPI.getClientPhone(tempClient_Phone, token)
                console.log(response);
                setDataClient(response.data.client)
                console.log(response.data.client);

                setClient_phone(tempClient_Phone)
                ErrorAlert(" ", "Cliente guardado para la transaccion", "success")
                setHandler(1)
            } catch (err) {
                console.log(err);
                ErrorAlert(" ", "Ocurrio un error en la consulta", "error")
            }
        }
    }

    const handlerSavePhone = () => {
        setClient_phone(tempClient_Phone)
        ErrorAlert(" ", "Cliente guardado para la transaccion", "success")
        setShowModal(false)
    }

    const handlerSaveLocator = (number) => {
        console.log(number);
        if (number == "" || number == null || number == undefined) {
            setTempClient_Phone("0")
        } else {
            setTempClient_Phone(number)
        }
    }

    //Hook to load the initial info
    useEffect(() => {
        setHandler(0)
    }, [handler]);


    return (
        <>




            <div className="sp-dl">
                <div className="sp-dl__head">
                    <span className="sp-dl__title"><i className="uil uil-users-alt"></i>Ingresar número</span>
                </div>

                <div className="sp-dl__body">
                    {/* Buscar por número */}
                    <div className="sp-dl__search">
                        <div className="sp-dl__inputwrap">
                            <i className="uil uil-phone sp-dl__inputic"></i>
                            <input
                                type="text"
                                className="sp-dl__input"
                                placeholder="Ingrese número..."
                                onChange={(e) => (handlerSaveLocator(e.target.value))}
                            />
                        </div>
                        <button className="sp-dl__btn" onClick={async () => getClientByPhone()}>
                            <i className="uil uil-search"></i> Validar
                        </button>
                    </div>

                    {/* Resultado */}
                    <div className="sp-dl__result">
                        {dataClient.length == 0 ? (
                            <div className="sp-dl__empty">
                                <i className="uil uil-user-times"></i>
                                <span>No se encontraron datos</span>
                            </div>
                        ) : (
                            dataClient.map((client, idx) => (
                                <div className="sp-dl__client" key={idx}>
                                    <div className="sp-dl__avatar">{(client.name || "C").slice(0, 1).toUpperCase()}</div>
                                    <div className="sp-dl__info">
                                        <div className="sp-dl__name">{client.name}</div>
                                        <div className="sp-dl__meta"><i className="uil uil-phone"></i> {client.phone}</div>
                                        <div className="sp-dl__meta"><i className="uil uil-envelope"></i> {client.email}</div>
                                    </div>
                                    <div className="sp-dl__points">
                                        <span className="sp-dl__points-val" translate="no">{client.points}</span>
                                        <span className="sp-dl__points-label">pts</span>
                                    </div>
                                </div>
                            ))
                        )}
                    </div>
                </div>
            </div>
        </>
    )
}

export default ModalDonlee